import { cn } from '~/styling';

import { useProductDetails } from '~/framework/routes/products/providers';

export function StockStatus() {
  const { isAvailable } = useProductDetails();

  return (
    <div
      className={cn(
        {
          'border border-primary-1-80 text-primary-1-80': isAvailable == true,
          'border border-primary-5-80 text-primary-5-80': isAvailable == false,
        },
        'inline-flex w-fit rounded px-4 py-2 text-xs font-semibold uppercase leading-3 tracking-wider'
      )}
    >
      {isAvailable == null ? (
        <div className="h-5 w-12 animate-pulse rounded bg-neutral-2-20/70" />
      ) : (
        <div className="flex items-center space-x-2">
          <div
            className={cn(
              'h-2 w-2 rounded-full',
              isAvailable ? 'bg-primary-1-80' : 'bg-primary-5-80'
            )}
          />
          <div>{isAvailable ? 'In Stock' : 'Out of Stock'}</div>
        </div>
      )}
    </div>
  );
}
